// src/components/Maintenance.tsx
import React from 'react';
import {
  Typography,
  Box,
  Button,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const Maintenance = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: "url(/images/banner_main.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "white",
        p: { xs: 2, md: 3 },
        display: "flex",
        alignItems: "center",
      }}
    >
      <Stack
        spacing={4}
        sx={{ width: "100%" }}
      >
      <div style={{ textAlign: 'center', padding: '100px' }}>
        <h1>🚧 Under Maintenance 🚧</h1>
        <p>We are currently performing maintenance. Please check back later.</p>
      </div>
      </Stack>
    </Box>
  );
};

export default Maintenance;
